import {
  isNullOrEmptyString,
  singleOrArrayToArray,
} from '@dirootie-extensions/javascript';
import { SingleOrArray } from '@dirootie-extensions/typescript';
import { buildRestUrls } from './urls.utils';
import _ from 'lodash';

export type IdentifierPrefix = {
  route: 'route';
  view: 'view';
  entity: 'entity';
  dataSource: 'data_source';
};

const idWithoutPrefix = (values: SingleOrArray<string>) =>
  `${singleOrArrayToArray(values)
    .filter((x) => !isNullOrEmptyString(x))
    .map((x) => `${x}`)
    .join('_')}`;

export const idGenerator = (
  prefix: string,
  parentNames: SingleOrArray<string> = [],
  sufixes?: string[]
) => {
  const id = `${prefix}:${idWithoutPrefix(parentNames)}`;
  if (sufixes === undefined) {
    return id;
  }
  return sufixes.map((x) => ({ sufix: x, id: `${id}_${x}` }));
};

export const createIdGenerator = (
  prefix: string
): ((parentNames?: SingleOrArray<string>) => string) => {
  return (parentNames) => idGenerator(prefix, parentNames) as string;
};

export type IdentifierOptions =
  | {
      prefix?: string;
      area?: string;
      group?: string;
      parents?: string[];
      id: string;
      sufix?: string[];
    }
  | string[];

const idFromOptions = (op: IdentifierOptions) => {
  if (_.isArray(op)) {
    return idWithoutPrefix(op);
  }
  const result = idGenerator(
    op.prefix!,
    [(op.area = ''), (op.group = ''), ...(op.parents || []), op.id],
    op.sufix
  );
  return result;
};

const restDataSourceBuilder = (
  basePath: string,
  options: { params?: any; ids: IdentifierOptions } = { params: {}, ids: [] }
) => {
  const urls = buildRestUrls(basePath, options.params) as any;
  (options.ids as any).sufix = Object.keys(urls);
  (idFromOptions(options.ids) as { sufix: string; id: string }[]).map((x) => {
    urls[x.sufix] = {
      action: x.sufix,
      id: x.id,
      endpoint: urls[x.sufix],
      url: urls[x.sufix],
      key: x.id,
      type: 'REMOTE',
    };
  });
  return urls;
};

const dataSourceIdBuilder = (prefix: string) => {
  const idGenerator = createIdGenerator(prefix);
  return {
    create: {},
    api: {
      rest: {
        all: (
          basePath: string,
          options: { params?: any; ids: IdentifierOptions }
        ) => restDataSourceBuilder(basePath, options),
      },
    },
  };
};

export const idBuilder = () => {
  return {
    routes: {},
    dataSources: dataSourceIdBuilder('data_source'),
  };
};
